import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import ChatIcon from '@mui/icons-material/Chat';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import StorageIcon from '@mui/icons-material/Storage';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Box from '@mui/material/Box';
import { useTheme, useMediaQuery } from '@mui/material';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUser } from '../pages/getUserDB';

export default function ActionAreaCard() {
  const [isActive, setIsActive] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  useEffect(() => {
    const dataUser = async () => {
      const data = await getUser();
      if (data.status === 'ativo') {
        setIsActive(true);
      }
    }
    dataUser();
  }, []);

  const cards = [
    {
      icon: <ChatIcon />,
      title: "Typebot",
      link: 'https://painel.cabanalink.com',
      target: 'blank',
      description: "Ferramenta completa para criar e personalizar fluxos de conversas automatizadas para seu negócio."
    },
    {
      icon: <WhatsAppIcon />,
      title: "WhatsApp",
      link: '/whatsapp-settings',
      description: "Conecte e configure sua conta do WhatsApp para integrar com os bots e automatizar suas comunicações."
    },
    {
      icon: <StorageIcon />,
      title: "NocoDB",
      link: "https://nocodb.cabanalink.com",
      target: 'blank',
      description: "Banco de dados em nuvem para armazenar e gerenciar informações coletadas nos seus fluxos de conversas."
    },
    // {
    //   icon: <AttachMoneyIcon />,
    //   title: "Meu plano",
    //   description: "Gerencie seu plano de assinatura, visualize faturas e acompanhe detalhes do seu vencimento."
    // }
  ];

  const getGridColumns = () => {
    if (isMobile) return 'repeat(1, 1fr)';
    if (isTablet) return 'repeat(2, 1fr)';
    return 'repeat(4, 1fr)';
  };

  const getIconSize = () => {
    if (isMobile) return 60;
    return 80;
  };

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: getGridColumns(),
        gap: isMobile ? '0.75rem' : '1rem',
        width: '100%',
        padding: isMobile ? '0.5rem' : '1rem'
      }}
    >
      {cards.map((card, index) => (
        <Card
          key={index}
          onClick={() => {
            if (isActive) {
              if (card.target) {
                window.open(card.link, card.target);
              } else {
                navigate(card.link);
              }
            }
          }}
          sx={{
            height: '100%',
            cursor: isActive ? 'pointer' : 'default',
            opacity: isActive ? 1 : 0.2,
            transition: 'transform 0.1s ease-in-out',
            '&:hover': {
              transform: isActive ? 'scale(1.05)' : 'none',
            }
          }}
        >
          <Box sx={{
            p: isMobile ? 1 : 2,
            display: 'flex',
            justifyContent: 'center',
            height: isMobile ? '80px' : '120px',
            alignItems: 'center'
          }}>
            {React.cloneElement(card.icon, { sx: { fontSize: getIconSize() } })}
          </Box>
          <CardContent sx={{ flexGrow: 1, width: '100%' }}>
            <Typography gutterBottom variant={isMobile ? "h6" : "h5"} component="div">
              {card.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {card.description}
            </Typography>
          </CardContent>
        </Card>
      ))}
      <Card
        sx={{
          height: '100%',
          cursor: 'pointer',
          transition: 'transform 0.1s ease-in-out',
          '&:hover': {
            transform: 'scale(1.05)',
          }
        }}
        key='myplan'
        onClick={() => navigate('/payment')}
      >
        <Box sx={{
          p: isMobile ? 1 : 2,
          display: 'flex',
          justifyContent: 'center',
          height: isMobile ? '80px' : '120px',
          alignItems: 'center'
        }}>
          <AttachMoneyIcon sx={{ fontSize: getIconSize() }} />
          {/* {React.cloneElement(card.icon, { sx: { fontSize: getIconSize() } })} */}
        </Box>
        <CardContent sx={{ flexGrow: 1, width: '100%' }}>
          <Typography gutterBottom variant={isMobile ? "h6" : "h5"} component="div">
            Meu plano
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Gerencie seu plano de assinatura, visualize faturas e acompanhe detalhes do seu vencimento.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}